import React from 'react';

import { cn } from 'lib/helpers/utility';

import Icon from 'components/shared/Icon/Icon';
import Checkbox from 'components/shared/Checkbox/Checkbox';

const PacketFormRow = ({ form, index, isSelected, dragHandleProps, onToggle, formId }) => {
  const isRecent = formId && formId === form?.id;
  return (
    <div
      className={cn(
        'rounded-[10px] border border-solid bg-white p-3',
        isSelected ? 'border-primary-500' : 'border-neutral-100'
      )}>
      <div className="flex items-center gap-2">
        {isSelected && dragHandleProps && (
          <div
            {...dragHandleProps}
            className="flex h-6 w-6 shrink-0 cursor-grab items-center justify-center active:cursor-grabbing">
            <Icon icon="drag-drop-linear" size={16} color="neutral" shade={500} />
          </div>
        )}
        {isSelected && index != null && (
          <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-primary-100 text-[10px] font-600 text-primary-700">
            {index + 1}
          </span>
        )}
        <Checkbox
          key={form?.id}
          id={`packet-form-${form?.id}`}
          isChecked={!!isSelected}
          handleClick={() => onToggle(form?.id)}
        />
        <p className="font-500 text-primary-900">{form?.name}</p>
        {isRecent && <p className="text-[12px] font-500 text-success-500">Recently created</p>}
      </div>
    </div>
  );
};

export default React.memo(PacketFormRow);
